import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

export type ManageRendererParams = ICellRendererParams & {
  // callbacks passed from columnDef.cellRendererParams
  onView?: (row: any) => void;
  onEditAsNew?: (row: any) => void;
  onResume?: (row: any) => void;
  onDelete?: (row: any) => void;
};

@Component({
  selector: "app-manage-cell-renderer",
  templateUrl: "./manage-cell-renderer.component.html",
})
export class ManageCellRendererComponent implements ICellRendererAngularComp {
  params!: ManageRendererParams;
  isGroup = false;
  rowData: any;

  agInit(params: ManageRendererParams): void {
    this.params = params;
    this.isGroup = !!params.node?.group;
    this.rowData = params.data;
  }

  refresh(params: ManageRendererParams): boolean {
    this.agInit(params);
    return true;
  }

  onView() {
    this.params.onView?.(this.rowData);
  }
  onEditNew() {
    this.params.onEditAsNew?.(this.rowData);
  }
  onResume() {
    this.params.onResume?.(this.rowData);
  }
  onDelete() {
    this.params.onDelete?.(this.rowData);
  }
}
